<div class="app-resource-rule-selector-container full-width">
  @if (getFormArray(ruleForm.get('ruleFormArray'))?.controls?.length > 0) {
    <div class="guide-text">Select resources where...</div>
  } @else {
    No rules are applied.
  }
  <form [formGroup]="ruleForm" class="full-width">
    <div
      class="full-width rule-selector"
      id="tag-array"
      formArrayName="ruleFormArray"
      cdkDropList
      [cdkDropListData]="getFormArray(ruleForm.get('ruleFormArray')).controls"
      (cdkDropListDropped)="dropGroup($event)"
    >
      @for (ruleControl of getFormArray(ruleForm.get('ruleFormArray')).controls; track ruleControl; let i = $index) {
        <div class="full-width rule-or-row" cdkDrag [cdkDragDisabled]="false">
          @switch (isFormGroup(ruleControl)) {
            @case (true) {
              <div class="and-group-wrapper full-width">
                <!-- AND group Box starts -->
                <div class="and-group-and comparator half-margin-right">{{ i !== 0 ? 'or' : '' }}</div>
                <div [formGroupName]="i" class="and-group flex-center-row full-width">
                  <div class="group-content flex-grow full-width">
                    <div formArrayName="rules">
                      <!-- text for future OR row when supported in groups -->
                      <!-- <div *ngIf="i !== 0" class="guide-text">Any of the following are true…</div> -->
                      @if (i !== 0) {
                        <div class="guide-text">All of the following are true…</div>
                      }
                      @for (
                        innerRuleControl of getFormArray(ruleControl.get('rules')).controls;
                        track innerRuleControl;
                        let j = $index
                      ) {
                        <div [formGroupName]="j" class="flex-center-row tag-row">
                          <div class="and-label operator">{{ j === 0 ? '' : 'and' }}</div>
                          <app-custom-rule-dropdown
                            formControlName="filterType"
                            cssClass="arpio-input full-width rule-type"
                            [class.ruletype-expanded-width-select]="
                              showResourceTypeSelect(innerRuleControl) || showResourceGroupSelect(innerRuleControl)
                            "
                            [options]="filterTypeOptions"
                            placeholder="Select type..."
                            (selectionChanged)="onFilterTypeChange(innerRuleControl)"
                          >
                          </app-custom-rule-dropdown>
                          @if (showTagSelect(innerRuleControl)) {
                            <div class="rule-overflow-wrapper">
                              @if (isTagsLoading) {
                                <input
                                  type="text"
                                  class="arpio-input row-element full-width"
                                  [value]="innerRuleControl.get('tagName')?.value || ''"
                                  disabled
                                  placeholder="Loading tags..."
                                />
                              }
                              @if (!isTagsLoading) {
                                <app-custom-rule-dropdown
                                  formControlName="tagName"
                                  cssClass="arpio-input row-element full-width"
                                  [options]="tagNameOptions"
                                  [allowAddNew]="true"
                                  [storageKey]="getStorageKey('tag-name')"
                                  placeholder="Select tag..."
                                  addNewPlaceholder="Search or add new tag..."
                                  (selectionChanged)="onTagNameChange(innerRuleControl)"
                                  (optionAdded)="onTagNameOptionAdded($event)"
                                  (optionRemoved)="onTagNameOptionRemoved($event)"
                                >
                                </app-custom-rule-dropdown>
                              }
                            </div>
                          }
                          <app-custom-rule-dropdown
                            formControlName="operator"
                            cssClass="has-value-div comparator arpio-input full-width"
                            [options]="getOperatorOptions(i, j)"
                            placeholder="Select operator..."
                          >
                          </app-custom-rule-dropdown>
                          @if (showTagSelect(innerRuleControl)) {
                            <div class="rule-overflow-wrapper">
                              @if (isTagsLoading) {
                                <input
                                  type="text"
                                  class="arpio-input row-element full-width"
                                  [value]="innerRuleControl.get('tagValue')?.value || ''"
                                  disabled
                                  placeholder="Loading tag values..."
                                />
                              }
                              @if (!isTagsLoading) {
                                <app-custom-rule-dropdown
                                  formControlName="tagValue"
                                  cssClass="arpio-input row-element full-width"
                                  [options]="getTagValueOptions(innerRuleControl.get('tagName')?.value || '')"
                                  [allowAddNew]="true"
                                  [storageKey]="getStorageKey('tag-value')"
                                  placeholder="Any value"
                                  addNewPlaceholder="Search or add new tag value..."
                                  (optionAdded)="onTagValueOptionAdded($event, innerRuleControl.get('tagName')?.value)"
                                  (optionRemoved)="
                                    onTagValueOptionRemoved($event, innerRuleControl.get('tagName')?.value)
                                  "
                                >
                                </app-custom-rule-dropdown>
                              }
                            </div>
                          }
                          @if (showResourceTypeSelect(innerRuleControl)) {
                            <app-custom-rule-dropdown
                              formControlName="resourceType"
                              cssClass="arpio-input full-width"
                              [options]="resourceTypeOptions"
                              placeholder="Select resource type..."
                            >
                            </app-custom-rule-dropdown>
                          }
                          @if (showResourceGroupSelect(innerRuleControl)) {
                            <app-custom-rule-dropdown
                              formControlName="resourceGroup"
                              cssClass="arpio-input full-width"
                              [options]="resourceGroupOptions"
                              placeholder="Select resource group..."
                              [allowAddNew]="true"
                              [storageKey]="getStorageKey('resource-group')"
                              addNewPlaceholder="Search..."
                            >
                            </app-custom-rule-dropdown>
                          }
                          @if (!readonly) {
                            <div class="remove-btn margin-right" (click)="removeTagAt(i, j)">
                              <svg lucideTrash2 title="Remove this rule"></svg>
                            </div>
                          }
                          <div class="and-group-controls-container">
                            @if (!readonly) {
                              <div class="and-btn margin-right" (click)="addOrRow(i, j)">
                                <svg lucidePlus class="add-rule-icon" title="Add rule in this group"></svg>
                              </div>
                            }
                            @if (!readonly) {
                              <div class="margin-right">
                                <div class="remove-btn" (click)="removeAllRowsInGroup(i)">
                                  <svg lucideTrash2 title="Remove all rules in this group"></svg>
                                </div>
                              </div>
                            }
                            <div class="drag-handle-container" cdkDragHandle>
                              <svg
                                lucideGripVertical
                                class="drag-handle"
                                aria-hidden="true"
                                title="Drag to reorder"
                              ></svg>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            @default {
              <div [formGroupName]="i" class="flex-center-row tag-row or-label">
                <!-- OR group Box starts -->
                <div class="or-label or-spacer operator">
                  {{ i > 0 ? 'or' : '' }}
                </div>
                <app-custom-rule-dropdown
                  formControlName="filterType"
                  cssClass="arpio-input full-width rule-type"
                  [class.ruletype-expanded-width-select]="
                    showResourceTypeSelect(ruleControl) || showResourceGroupSelect(ruleControl)
                  "
                  [options]="filterTypeOptions"
                  placeholder="Select type..."
                  (selectionChanged)="onFilterTypeChange(ruleControl)"
                >
                </app-custom-rule-dropdown>
                @if (showTagSelect(ruleControl)) {
                  <div class="rule-overflow-wrapper">
                    @if (isTagsLoading) {
                      <input
                        type="text"
                        class="arpio-input row-element full-width"
                        [value]="ruleControl.get('tagName')?.value || ''"
                        disabled
                        placeholder="Loading tags..."
                      />
                    }
                    @if (!isTagsLoading) {
                      <app-custom-rule-dropdown
                        formControlName="tagName"
                        cssClass="arpio-input row-element full-width"
                        [options]="tagNameOptions"
                        [allowAddNew]="true"
                        [storageKey]="getStorageKey('tag-name')"
                        placeholder="Select tag..."
                        addNewPlaceholder="Search or add new tag..."
                        (selectionChanged)="onTagNameChange(ruleControl)"
                        (optionAdded)="onTagNameOptionAdded($event)"
                        (optionRemoved)="onTagNameOptionRemoved($event)"
                      >
                      </app-custom-rule-dropdown>
                    }
                  </div>
                }
                <div class="has-value-div comparator row-element">is</div>
                @if (showTagSelect(ruleControl)) {
                  <div class="rule-overflow-wrapper">
                    @if (isTagsLoading) {
                      <input
                        type="text"
                        class="arpio-input row-element full-width"
                        [value]="ruleControl.get('tagValue')?.value || ''"
                        disabled
                        placeholder="Loading tag values..."
                      />
                    }
                    @if (!isTagsLoading) {
                      <app-custom-rule-dropdown
                        formControlName="tagValue"
                        cssClass="arpio-input row-element full-width"
                        [options]="getTagValueOptions(ruleControl.get('tagName')?.value || '')"
                        [allowAddNew]="true"
                        [storageKey]="getStorageKey('tag-value')"
                        placeholder="Any value"
                        addNewPlaceholder="Search or add new value..."
                        (optionAdded)="onTagValueOptionAdded($event, ruleControl.get('tagName')?.value)"
                        (optionRemoved)="onTagValueOptionRemoved($event, ruleControl.get('tagName')?.value)"
                      >
                      </app-custom-rule-dropdown>
                    }
                  </div>
                }
                @if (showResourceTypeSelect(ruleControl)) {
                  <app-custom-rule-dropdown
                    formControlName="resourceType"
                    cssClass="arpio-input full-width"
                    [options]="resourceTypeOptions"
                    placeholder="Select resource type..."
                  >
                  </app-custom-rule-dropdown>
                }
                @if (showResourceGroupSelect(ruleControl)) {
                  <app-custom-rule-dropdown
                    formControlName="resourceGroup"
                    cssClass="arpio-input full-width"
                    [options]="resourceGroupOptions"
                    placeholder="Select resource group..."
                    [allowAddNew]="true"
                    [storageKey]="getStorageKey('resource-group')"
                    addNewPlaceholder="Search..."
                  >
                  </app-custom-rule-dropdown>
                }
                @if (!readonly) {
                  <div class="remove-btn margin-right" (click)="removeTagAt(i, j)">
                    <svg lucideTrash2 title="Remove this rule"></svg>
                  </div>
                }
                <div class="drag-handle-container" cdkDragHandle>
                  <svg lucideGripVertical class="drag-handle" aria-hidden="true" title="Drag to reorder"></svg>
                </div>
              </div>
            }
          }
        </div>
      }
      @if (!readonly) {
        <div class="flex-row-start items-center gap-4 margin-top">
          <a
            id="add-rule-button"
            class="and-btn third-margin-right"
            (click)="addOrRow(getFormArray(ruleForm.get('ruleFormArray')).controls.length - 1)"
          >
            <svg lucidePlus class="add-rule-icon half-margin-right" title="Add new rule"></svg>
            <span class="underline">Add Rule</span>
          </a>
          <a
            id="add-compound-rule-button"
            class="and-btn"
            (click)="addAndGroup(getFormArray(ruleForm.get('ruleFormArray')).controls.length - 1)"
          >
            <svg lucidePlus class="add-rule-icon third-margin-right" title="Add new rule group"></svg>
            <span class="underline">Add Compound Rule</span>
          </a>
        </div>
      }
    </div>
  </form>
</div>
